import React, { createContext, useContext, useState, useCallback } from 'react'
import {
  InternationalizationContextProps,
  TranslationKeys,
  Translations,
} from './internationalization.types'
import { defaultTranslations } from './defaultTranslations'
import { path } from 'ramda'

const InternationalizationContext = createContext<
  InternationalizationContextProps | undefined
>(undefined)

export const useInternationalizationCore = () => {
  const context = useContext(InternationalizationContext)

  if (!context) {
    throw new Error(
      'useInternationalizationCore must be used within InternationalizationProviderCore'
    )
  }

  return context
}

export const InternationalizationProviderCore: React.FC<{
  children: React.ReactNode
  initialTranslations?: Partial<Translations>
  t?: (key: TranslationKeys) => string
}> = ({ children, initialTranslations = {}, t }) => {
  const [translations] = useState<Translations>({
    ...defaultTranslations,
    ...initialTranslations,
  })

  const getTranslation = useCallback(
    (key: TranslationKeys) => {
      return t ? t(key) : path(key.split('.'), translations)
    },
    [translations, t]
  )

  return (
    <InternationalizationContext.Provider
      value={{ t: getTranslation } as InternationalizationContextProps}
    >
      {children}
    </InternationalizationContext.Provider>
  )
}
